import { MENUS_ENDPOINTS } from "./endpoints";
import type { WeeklyMenu } from "./types";
import { apiRequestWithData } from "../shared";

export default async function getCurrentMenu(weekStart?: string): Promise<WeeklyMenu> {
  const url = weekStart ? `${MENUS_ENDPOINTS.GET_CURRENT}?week_start=${weekStart}` : MENUS_ENDPOINTS.GET_CURRENT;
  return apiRequestWithData<WeeklyMenu>(url);
}
